import type { ReactNode } from 'react';

import STYLES from './ResponsiveSquare.module.scss';

type Props = {
  className?: string;
  roundedCorners?: boolean;
  children: ReactNode;
};

const ResponsiveSquare = ({ children, className, roundedCorners }: Props) => {
  const classNames = [STYLES.ResponsiveSquare];

  if (roundedCorners) {
    classNames.push(STYLES.ResponsiveSquare__roundedCorners);
  }

  if (className) {
    classNames.push(className);
  }

  return (
    <div className={classNames.join(' ')}>
      <div className={STYLES.ResponsiveSquare__content}>{children}</div>
    </div>
  );
};

export default ResponsiveSquare;
